import React from 'react';
import { motion } from 'framer-motion';
import { FaPencilAlt, FaTrash, FaBox, FaStore } from 'react-icons/fa';

const cardVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: (index) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: index * 0.1,
      duration: 0.5,
      ease: "easeOut"
    }
  })
};

const ProfileCard = ({ profile, itemCount, onView, onEdit, onDelete, index }) => {
  return (
    <motion.div
      custom={index}
      initial="hidden"
      animate="visible"
      variants={cardVariants}
      onClick={onView}
      className="bg-white dark:bg-gray-800 rounded-xl p-6 shadow-lg hover:shadow-2xl 
        transition-all cursor-pointer select-none"
    >
      <div className="flex justify-between items-start mb-4">
        {/* Store Logo/Image or Icon */}
        {profile.storeImageUrl ? (
          <div className="h-12 w-12 rounded-lg overflow-hidden bg-white dark:bg-gray-700">
            <img 
              src={profile.storeImageUrl} 
              alt={profile.name}
              className="h-full w-full object-cover"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
            <div 
              className="h-12 w-12 rounded-lg bg-gradient-to-r from-teal-400 to-cyan-600 flex items-center justify-center"
              style={{ display: 'none' }}
            >
              <FaStore className="text-white text-2xl" />
            </div>
          </div>
        ) : (
          <div className="h-12 w-12 rounded-lg bg-gradient-to-r from-teal-400 to-cyan-600 
            flex items-center justify-center">
            <FaStore className="text-white text-2xl" />
          </div>
        )}
        <div className="flex space-x-2">
          <button 
            onClick={(e) => { 
              e.stopPropagation(); 
              onEdit(); 
            }}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          >
            <FaPencilAlt className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300" />
          </button>
          <button 
            onClick={(e) => { 
              e.stopPropagation(); 
              onDelete(); 
            }}
            className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
          >
            <FaTrash className="text-gray-400 hover:text-red-600" />
          </button>
        </div>
      </div>
      
      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
        {profile.name}
      </h3>
      
      <p className="text-gray-600 dark:text-gray-400 text-sm mb-4 line-clamp-2">
        {profile.description || 'No description'}
      </p>
      
      <div className="flex justify-between items-center pt-4 border-t dark:border-gray-700">
        <span className="text-sm text-gray-500 dark:text-gray-400">
          {itemCount} {itemCount === 1 ? 'item' : 'items'}
        </span>
        <span className="text-xs px-2 py-1 rounded-full bg-teal-100 dark:bg-teal-900 
          text-teal-800 dark:text-teal-200">
          <FaBox className="inline mr-1" />
          Inventory
        </span>
      </div>
    </motion.div>
  );
};

export default ProfileCard;

